import { render, staticRenderFns } from "./MoveKeyDialog.vue?vue&type=template&id=0772611d&scoped=true&"
import script from "./MoveKeyDialog.vue?vue&type=script&lang=js&"
export * from "./MoveKeyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0772611d",
  null
  
)

export default component.exports